import Splide from '@splidejs/splide';

class ProductsTabs {
  constructor() {
    if(!document.querySelector('.js-ProductsTabs-cards')) {
      return
    }

    this.btns = document.querySelectorAll('.js-ProductsTabs-btn')
    this.cards = this.initCards(document.querySelector('.js-ProductsTabs-cards'))
    this.cards.mount()

    this.btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.cards.go(parseInt(btn.getAttribute('data-index')))

        e.preventDefault()
      })
    })
  }

  initCards = (el) => {
    const slider = new Splide(el, {
      gap: 15,
      padding: {
        left: 20,
        right: 20
      },
      pagination: false,
      arrows: false,
      fixedWidth: 300,
      omitEnd: true,
      mediaQuery: 'min',
      breakpoints: {
        1024: {
          gap: 30,
          fixedWidth: 630,
          padding: {
            right: 300
          },
        },
        768: {
          gap: 20,
          fixedWidth: 300,
          padding: {
            right: 300
          },
        },
      }
    })

    return slider;
  }
}

new ProductsTabs();
